import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { useAppContext } from '../context/AppContext';
import WaterGlassLoader from '../components/WaterGlassLoader';

const PRODUCT_IMAGES = {
  'Акватория': '/aquatory.png',
  'Ладица': '/ladica.png',
};

export default function CatalogScreen() {
  const navigate = useNavigate();
  const { addToCart, updateCartQuantity, cart } = useAppContext();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getCartItem = (productId) => cart.find(i => i.product.id === productId);

  const fetchProducts = async () => {
    setLoading(true); setError(null);
    try {
      const data = await api.products.list();
      setProducts(data || []);
    } catch { setError('Нет соединения с сервером'); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchProducts(); }, []);

  const handleAdd = (item) => {
    if (cart.length > 0 && cart[0].product.brand !== item.brand) {
      alert(`В корзине уже есть ${cart[0].product.brand}. Оформите сначала текущий заказ или очистите корзину.`);
      return;
    }
    addToCart(item);
  };

  if (loading) return (
    <div style={centered}>
      <WaterGlassLoader color="#1A6DB5" />
      <p style={{ color: 'var(--text-light)', fontSize: 14, marginTop: 12 }}>Загружаем каталог...</p>
    </div>
  );

  if (error) return (
    <div style={centered}>
      <p style={{ color: '#FF3B30', fontSize: 16, marginBottom: 16 }}>⚠ {error}</p>
      <button onClick={fetchProducts} style={{ padding: '8px 24px', borderRadius: 10, border: '1.5px solid var(--primary)', background: 'none', color: 'var(--primary)', fontWeight: 700, fontSize: 16 }}>Повторить</button>
    </div>
  );

  return (
    <div style={{ padding: '0 16px' }}>
      <h1 style={{ fontSize: 28, fontWeight: 'bold', color: 'var(--primary)', marginTop: 24 }}>Каталог воды</h1>
      <p style={{ fontSize: 16, color: 'var(--text-light)', marginBottom: 24 }}>Выберите подходящую марку</p>

      {products.map(item => {
        const cartItem = getCartItem(item.id);
        return (
          <div key={item.id} style={cardStyle}>
            {/* Шапка карточки */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
              {PRODUCT_IMAGES[item.brand]
                ? <img src={PRODUCT_IMAGES[item.brand]} alt={item.brand} style={{ width: 48, height: 64, objectFit: 'contain', marginRight: 12, borderRadius: 8 }} />
                : <span style={{ fontSize: 36, marginRight: 12 }}>{item.emoji || '💧'}</span>}

              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--primary)' }}>{item.brand}</div>
                <div style={{ fontSize: 13, color: 'var(--text-light)' }}>{item.volume}</div>
              </div>
              <div style={{ fontSize: 20, fontWeight: 'bold', color: 'var(--text)' }}>{item.price} ₽</div>
            </div>

            {/* Описание */}
            {item.about && <p style={{ fontSize: 13, color: 'var(--text-light)', lineHeight: 1.5, marginBottom: 12 }}>{item.about}</p>}

            {/* Кнопки */}
            <div style={{ display: 'flex', gap: 8 }}>
              <button
                onClick={() => navigate('/water-detail', { state: { product: item } })}
                style={{ flex: 1, padding: '8px', borderRadius: 10, border: '1.5px solid var(--primary)', background: 'none', color: 'var(--primary)', fontWeight: 700, fontSize: 15 }}
              >
                Подробнее
              </button>

              {cartItem ? (
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'var(--primary)', borderRadius: 10, padding: '0 8px' }}>
                  <button onClick={() => updateCartQuantity(item.id, cartItem.quantity - 1)} style={{ background: 'none', color: '#fff', fontSize: 22, fontWeight: 700, padding: '4px 8px' }}>−</button>
                  <span style={{ color: '#fff', fontWeight: 700, fontSize: 16, minWidth: 24, textAlign: 'center' }}>{cartItem.quantity}</span>
                  <button onClick={() => updateCartQuantity(item.id, cartItem.quantity + 1)} style={{ background: 'none', color: '#fff', fontSize: 22, fontWeight: 700, padding: '4px 8px' }}>+</button>
                </div>
              ) : (
                <button
                  onClick={() => handleAdd(item)}
                  style={{ flex: 1, padding: '8px', borderRadius: 10, background: 'var(--primary)', color: '#fff', fontWeight: 700, fontSize: 15 }}
                >
                  В корзину
                </button>
              )}
            </div>
          </div>
        );
      })}
      <div style={{ height: 40 }} />
    </div>
  );
}

const centered = { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '70vh' };
const cardStyle = { background: 'var(--card)', borderRadius: 14, padding: 16, marginBottom: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
